/**
 * @file ppde页面
 * @author FengGuang(fengguang01@baidu.com)
 */
import {useEffect, useState} from 'react';
import moment from 'moment';
import {fetchGetPpdeMemberInfo} from '../../api/pages/ppdeApi';
import {IMembersProps} from './components/members/types';

// 预请求
let preRequest: any = {
    fetchGetPpdeInfo: fetchGetPpdeMemberInfo()
};

const usePpdeMLHooks = () => {
    const [members, setMembers] = useState<IMembersProps>(() => {
        return {
            list: Array.from({length: 28})
        };
    });

    useEffect(() => {
        (async () => {
            const fetchFunc = preRequest.fetchGetPpdeInfo || fetchGetPpdeMemberInfo();
            delete preRequest.fetchGetPpdeInfo;

            const res = await fetchFunc.catch(() => {
                // ignore
            });
            if (res) {
                const pageData = res.body.result?.pageData || {};

                const mb = pageData.member || {};
                const mbGroup: any[] = Array.isArray(mb.group) ? mb.group : [];
                setMembers({
                    list: mbGroup.map((item) => {
                        return {
                            company: item.company,
                            entryTime: item.entryTime ? moment(item.entryTime) : undefined,
                            img: item.img,
                            link: item.link,
                            name: item.name,
                            size: item.sizeLarge ? 'large' : undefined,
                            position: item.position
                        };
                    })
                });
            }
        })();
    }, []);

    return {
        members
    };
};

export default usePpdeMLHooks;
